import {AuthService } from '@/utils/service'
import Vue from 'vue'

export const getChannelConf = () => {
    return new AuthService({
        url: '/3rd/conf/view',
        method: 'get',
        data: {
            productId: "DM-QBXJ",
            portal: Vue.cookie("portal"),
            partner: Vue.cookie("partner")
        }
    })
}

export const refreshChannelConf = () => {
    return new AuthService({
        url: '/api/3rd/conf/refresh',
        method: 'post',
        data: {
            productId: "DM-QBXJ",
            portal: Vue.cookie("portal"),
            partner: Vue.cookie("partner")
        }
    })
}

export const autoChannelConf = () => {
    return new AuthService({
        url: '/api/3rd/conf/auto',
        method: 'post',
        data: {
            productId: "DM-QBXJ",
            portal: Vue.cookie("portal"),
            partner: Vue.cookie("partner")
        }
    })
}
